import { render, staticRenderFns } from "./SuccessAgree.vue?vue&type=template&id=0040ea0a&scoped=true"
import script from "./SuccessAgree.vue?vue&type=script&lang=js"
export * from "./SuccessAgree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0040ea0a",
  null
  
)

export default component.exports